define('controllers/retargetingpixel',['require'],function(require) {
	return function() {
	    /*Code to load in adroll script*/
        //TODO: have adroll id in customer table. If cookie customer, use that or use logged in person's employer. Don't show retargeting pixel if they're already RPM?
		adroll_adv_id = "YARITBSK6NH2ZIPMGKFZJ6";
        adroll_pix_id = "DH2RCMWQNBDTZFN2NXDOC3";
        (function () {
            var oldonload = window.onload;
            window.onload = function () {
                __adroll_loaded = true;
                var scr = document.createElement("script");
                var host = (("https:" == document.location.protocol) ? "https://s.adroll.com" : "http://a.adroll.com");
                scr.setAttribute('async', 'true');
                scr.type = "text/javascript";
                scr.src = host + "/j/roundtrip.js";
                ((document.getElementsByTagName('head') || [null])[0] ||
    document.getElementsByTagName('script')[0].parentNode).appendChild(scr);
                if (oldonload) { oldonload() }
            };
        } ());
	};
});
